export default {
  methods: {
    parseErrorMsg(e) {
      if (e.response) {
        if (e.response.status == 400) {
          if (e.response.data.error) {
            window.console.error(e.response.data.message);
            return e.response.data.error;
          }
          return e.response.data.msg;
        } else if (e.response.status == 403) {
          return "forbidden error";
        } else if (e.response.status == 404) {
          return "function not found";
        } else {
          return "errors";
        }
      } else {
        return e.toString();
      }
    }
  }
};
